module.exports = new __parcel__URL__("text-fields-a.0af48e87.png").toString();